import { render, staticRenderFns } from "./ModalAnotacao.vue?vue&type=template&id=c0e9bdea&lang=pug"
import script from "./ModalAnotacao.vue?vue&type=script&lang=js"
export * from "./ModalAnotacao.vue?vue&type=script&lang=js"
import style0 from "./ModalAnotacao.vue?vue&type=style&index=0&id=c0e9bdea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports